import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SearchEmptySplashComponent} from './search-empty-splash.component';

@NgModule({
  declarations: [
    SearchEmptySplashComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    SearchEmptySplashComponent,
  ],
})
export class SearchEmptySplashModule {
}
